import { ChangeDetectionStrategy, Component, booleanAttribute, input } from '@angular/core';

@Component({
    standalone: true,
    selector: 'sirius-container',
    template: '<ng-content></ng-content>',
    styleUrl: './container.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class.sir-container--fluid]': 'fluid()',
    },
})
export class ContainerComponent {
    readonly fluid = input(false, { transform: booleanAttribute });
}
